import { Box, useTheme } from "@mui/material";

interface HeroSectionWrapperProps {
    children: JSX.Element;
}

export const HeroSectionWrapper = (props: HeroSectionWrapperProps) => {
    const { children } = props;
    const theme = useTheme();

    return <Box sx={{ padding: theme.spacing(2, 0) }}>{children}</Box>;
};
